import { Button, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import LookupTool from "./lookupTool";
import PropertyTable from "./propertyTable";
import { useState, useEffect } from "react";
import { Add } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { resetContacts } from "../features/contactSlice";
import { setContacts } from "../features/assessorSlice";
import { getDefinitions } from "../services/settingsService";
import { setDefinitions } from "../features/settingsSlice";
import {
  loadCIDIntoAssessor,
  loadPropertyIntoAssessor,
} from "../services/assessorLoad";
import {
  readSelectedCid,
  readSelectedProperty,
  persistSelectedProperty,
} from "../utils/assessorPersistence";

const QuickAssessor = () => {
  const [toolOpen, toggleTool] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetContacts());
    dispatch(setContacts([]));
    getDefinitions().then((defs) => {
      if (defs) {
        dispatch(setDefinitions(defs));
      }
    });

    // Restore the CID + property that were open before a refresh. Capture the
    // saved property first — loadCIDIntoAssessor clears it — then reopen it.
    const savedCid = readSelectedCid();
    const savedProperty = readSelectedProperty();
    if (savedCid !== null) {
      (async () => {
        try {
          await loadCIDIntoAssessor(dispatch, savedCid);
          if (savedProperty !== null) {
            await loadPropertyIntoAssessor(dispatch, savedProperty);
          }
        } catch (err) {
          // Stale/deleted property or a transient load failure — drop the
          // property so we don't retry a dead id on the next refresh.
          console.log(err);
          persistSelectedProperty(null);
        }
      })();
    }
  }, [dispatch]);

  return (
    <Grid container sx={{ p: { xs: 1, md: 2 } }} spacing={2}>
      <Grid item xs={12}>
        <Card variant="outlined">
          <CardContent>
            <Stack
              direction={{ xs: "column", md: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", md: "center" }}
              spacing={1}
            >
              <BoxCopy />
              <Button
                variant={toolOpen ? "outlined" : "contained"}
                color={toolOpen ? "inherit" : "primary"}
                onClick={() => toggleTool(!toolOpen)}
                startIcon={!toolOpen ? <Add /> : null}
              >
                {toolOpen ? "Hide Property Editor" : "Open Property Editor"}
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Grid>

      {toolOpen ? (
        <Grid item xs={12} lg={3}>
          <LookupTool toggleLookup={toggleTool} />
        </Grid>
      ) : null}

      <Grid item xs={12} lg={toolOpen ? 9 : 12}>
        <PropertyTable toggleLookup={toggleTool} />
      </Grid>
    </Grid>
  );
};

const BoxCopy = () => (
  <Stack spacing={0.5}>
    <Typography variant="h5">Quick Assessor</Typography>
    <Typography variant="body2" color="text.secondary">
      Manage CID parcels, assign contacts, and update assessment details with a single
      workflow.
    </Typography>
  </Stack>
);

export default QuickAssessor;
